module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Report Passcode")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "security",
      "append-icon": _vm.show1 ? 'visibility' : 'visibility_off',
      "type": _vm.show1 ? 'text' : 'password',
      "label": "Enter Passcode",
      "error-messages": _vm.passcodeErrors,
      "hint": "Recommended for at least 8 characters",
      "counter": ""
    },
    on: {
      "click:append": function($event) {
        _vm.show1 = !_vm.show1
      },
      "input": function($event) {
        return _vm.$v.passcode.$touch()
      },
      "blur": function($event) {
        return _vm.$v.passcode.$touch()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
        $event.preventDefault();
      },
      "paste": _vm.preventPasteSpaces
    },
    model: {
      value: (_vm.passcode),
      callback: function($$v) {
        _vm.passcode = $$v
      },
      expression: "passcode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.resetPasscode
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a01fbec2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/ReportPasscodeModal.vue
// module id = 2254
// module chunks = 0